import React from 'react';

const WidgetTabsContent: React.FC = ({ children }) => {
    return <>{children}</>;
};

export default WidgetTabsContent;
